import { IProvider } from "./provider.types";
import { RecoverRepository } from "@/repository/recover/RecoverRepository";
import { SalonsRepository } from "@/repository/salons/SalonsRepository";
import { AccessRepository } from "@/repository/salons/AccessRepository";
// Клиенты
import { ClientsRepository } from "@/repository/clients/ClientsRepository";
import { ClientsCategoryRepository } from "@/repository/clients/ClientsCategoryRepository";
import { ClientsAccountHistoryRepository } from "@/repository/clients/ClientsAccountHistory";
import { ClientsAccountsAllRepository } from "@/repository/clients/ClientsAccountsAll";
// Клиенты END
import { TerritoryRepository } from "@/repository/territory/TerritoryRepository";
import WorkersRepository from "@/repository/workers/WorkersRepository";
import StaffScheduleRepository from "@/repository/workers/StaffScheduleRepository";
import RolesRepository from "@/repository/user/roles/RolesRepository";
import CategoryRepository from "@/repository/category/CategoryRepository";
import { StatusRepository } from "@/repository/status/StatusRepository";
import { PositionRepository } from "@/repository/position/PositionRepository";
import { SalarySchemeRepository } from "@/repository/salaryScheme/SalarySchemeRepository";
import { CurrencyRepository } from "@/repository/currency/СurrencyRepository";
import { ManagerRepository } from "@/repository/manager/ManagerRepository";
import { GroupsRepository } from "@/repository/groups/GroupsRepository";
import { authRepository } from "@/repository/user/auth/authRepository";
// Услуги
import { ServicesRepository } from "@/repository/services/ServicesRepository";
import { ServiceCategoryRepository } from "./servicesCategory/ServicesCategoryRepository";
import { ServicesCategoryNomenclatureRepository } from "./servicesCategory/ServicesCategoryNomenclatureRepository";
import { ServiceCosmetologistsRepository } from "@/repository/serviceCosmetologists/ServiceCosmetologistsRepository";
import { ConsumablesRepository } from "@/repository/consumables/ConsumablesRepository";
// Услуги END
import { UserRepository } from "@/repository/user/UserRepository";
import { PartnerRepository } from "@/repository/partner/PartnerRepository";
import SourcesRepository from "@/repository/sources/SourcesRepository";
import CategoryClientRepository from "@/repository/categoryClient/CategoryClientRepository";
// лояльность
import { LoyaltyCertRepository } from "@/repository/loyalty/Cert/LoyaltyCertRepository";
import { LoyaltyCertTypeRepository } from "@/repository/loyalty/Type/LoyaltyCertTypeRepository";
import { LoyaltyBonusRepository } from "@/repository/loyalty/Bonus/LoyaltyBonus/LoyaltyBonusRepository";
import { LoyaltyBonusTypeRepository } from "@/repository/loyalty/Bonus/LoyaltyBonusType/LoyaltyBonusTypeRepository";
import { LoyaltySubscriptionRepository } from "@/repository/loyalty/Subscription/LoyaltySubscriptionRepository";
import { LoyaltySubscriptionTypeRepository } from "@/repository/loyalty/Subscription/Type/LoyaltySubscriptionTypeRepository";
import { LoyaltyStockRepository } from "@/repository/loyalty/Stock/LoyaltyStockRepository";
// Финансы
import { CashboxRepository } from "@/repository/finance/cashbox/CashboxRepository";
import { CashboxTypeRepository } from "@/repository/finance/cashbox/CashboxTypeRepository";
import { CounterpartiesRepository } from "@/repository/finance/counterparties/CounterpartiesRepository";
import { CounterpartiesTypeRepository } from "@/repository/finance/counterparties/CounterpartiesTypeRepository";
import { PaymentArticlesRepository } from "@/repository/finance/payment_articles/PaymentArticlesRepository";
import { PaymentArticlesTypeRepository } from "@/repository/finance/payment_articles/PaymentArticlesTypeRepository";
import { FinanceOperationsRepository } from "@/repository/finance/finance_operations/FinanceOperationsRepository";
// Финансы END

// Товары
import { ProductsRepository } from "@/repository/warehouse/Products/ProducsRepository";
import { ProductsStockRepository } from "@/repository/warehouse/Products/ProductsStockRepository";
import { ProductsCategoryRepository } from "@/repository/warehouse/Category/CategoryRepository";
import { ProductsUnitRepository } from "@/repository/warehouse/Unit/UnitRepository";
import { ProductsTaxRepository } from "@/repository/warehouse/Tax/TaxRepository";
import { ProductsTaxSystemRepository } from "@/repository/warehouse/TaxSystem/TaxSystemRepository";
// Склады
import { OperationsRepository } from "@/repository/warehouse/Operations/OperationsRepository";
import { OperationsMoveRepository } from "@/repository/warehouse/Operations/Move/OperationsMoveRepository";

import { WarehouseRepository } from "@/repository/warehouse/WarehouseRepository";
import { WarehouseTypesRepository } from "@/repository/warehouse/Types/WarehouseTypesRepository";
// Склады END

// Visits
import { VisitsRepository } from "./visits/VisitsRepository";
import { VisitsCategoryRepository } from "./visitsCategory/VisitCategoryRepository";
// Visits END

// Settings
import { SettingsUserRepository } from "./Settings/Users/SettingsUserRepository";
import { SettingsCashBoxRepository } from "./Settings/Finaces/SettingsCashBoxRepository";
import { CosmetologistUsersRepository } from "./Settings/Users/CosmetologistUserRepository";
import { NewsRepository } from "./Settings/NewsRepository";
import { VacancyRepository } from "./Settings/VacancyRepository";
import { VacancySectionRepository } from "./Settings/VacancySectionRepository";
import { ServiceDetailRepository } from "./Settings/ServiceDetailRepository";
import {ServicesNomenclatureRepository} from "@/repository/services/ServicesNomenclatureRepository";
import { DocumentsRepository } from "./documents/DocumentsRepository";
import reportsRepository from '@/UI/pages/reports/lib/ReportsRepository'
// Settings END

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const provider = (): IProvider => ({
    auth: new authRepository(),
    user: new UserRepository(),
    recover: new RecoverRepository(),
    salons: new SalonsRepository(),
    access: new AccessRepository(),

    clients: new ClientsRepository(),
    clientsCategories: new ClientsCategoryRepository(),
    clientsAccountHistory: new ClientsAccountHistoryRepository(),
    clientsAccountsAll: new ClientsAccountsAllRepository(),

    territory: new TerritoryRepository(),
    workers: new WorkersRepository(),
    staffSchedule: new StaffScheduleRepository(),
    roles: new RolesRepository(),
    category: new CategoryRepository(),
    sources: new SourcesRepository(),
    categoryClient: new CategoryClientRepository(),
    status: new StatusRepository(),
    position: new PositionRepository(),
    salaryScheme: new SalarySchemeRepository(),
    currency: new CurrencyRepository(),
    manager: new ManagerRepository(),
    groups: new GroupsRepository(),

    //Услуги
    services: new ServicesRepository(),
    servicesNomenclatures: new ServicesNomenclatureRepository(),
    servicesCategory: new ServiceCategoryRepository(),
    servicesCategoryNomenclature: new ServicesCategoryNomenclatureRepository(),
    serviceCosmetologists: new ServiceCosmetologistsRepository(),
    consumables: new ConsumablesRepository(),
    //Услуги

    partner: new PartnerRepository(),

    // Лояльность
    loyaltyCertType: new LoyaltyCertTypeRepository(),
    loyaltyCert: new LoyaltyCertRepository(),
    loyaltyBonusType: new LoyaltyBonusTypeRepository(),
    loyaltyBonus: new LoyaltyBonusRepository(),
    loyaltySubscriptionType: new LoyaltySubscriptionTypeRepository(),
    loyaltySubscription: new LoyaltySubscriptionRepository(),
    loyaltyStock: new LoyaltyStockRepository(),

    //Финансы
    cashbox: new CashboxRepository(),
    cashboxTypes: new CashboxTypeRepository(),
    counterparties: new CounterpartiesRepository(),
    counterpartiesType: new CounterpartiesTypeRepository(),
    paymentArticles: new PaymentArticlesRepository(),
    paymentArticlesType: new PaymentArticlesTypeRepository(),
    financeOperations: new FinanceOperationsRepository(),
    //Финансы

    //Визиты
    visits: new VisitsRepository(),
    visitsCategory: new VisitsCategoryRepository(),
    //Визиты

    //Товары
    products: new ProductsRepository(),
    productsStock: new ProductsStockRepository(),
    products_categories: new ProductsCategoryRepository(),
    products_unit: new ProductsUnitRepository(),
    products_tax: new ProductsTaxRepository(),
    products_taxsystem: new ProductsTaxSystemRepository(),

    //Склады
    operations: new OperationsRepository(),
    warehouse: new WarehouseRepository(),
    warehouseTypes: new WarehouseTypesRepository(),
    operationsMove: new OperationsMoveRepository(),

    //Settings
    settingsUser: new SettingsUserRepository(),
    userCosmetologist: new CosmetologistUsersRepository(),
    settingsCashBox: new SettingsCashBoxRepository(),
    news: new NewsRepository(),
    vacancy: new VacancyRepository(),
    vacancy_section: new VacancySectionRepository(),
    service_detail: new ServiceDetailRepository(),
    documents: new DocumentsRepository(),

    reports: new reportsRepository(),
});
